module.exports = __webpack_public_path__ + "static/img/clothing_08.6284233.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_08.png
// module id = WPF9
// module chunks = 0